export enum FlightCabinEnum {
  ECONOMY = 'ECONOMY',
  ECONOMY_STANDARD = 'ECONOMY_STANDARD',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST',
}
